import React, { useEffect, useRef, useState } from 'react';
import LegalCartaMarco from './LegalCartaMarco';
import { parrafosDocumento } from './legalLabels';

function LegalDocumentViewer({
  document,
  accepted,
  onAcceptChange,
  waiverOfWithdrawal,
  onWaiverChange,
  showWaiverOption,
  soloLectura = false,
}) {
  const [hasScrolledToEnd, setHasScrolledToEnd] = useState(soloLectura);
  const contentRef = useRef(null);

  useEffect(() => {
    if (soloLectura) {
      setHasScrolledToEnd(true);
      return undefined;
    }

    const container = contentRef.current;
    if (!container) return undefined;

    const checkScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        setHasScrolledToEnd(true);
      }
    };

    if (container.scrollHeight <= container.clientHeight) {
      setHasScrolledToEnd(true);
      return undefined;
    }

    container.addEventListener('scroll', checkScroll);
    return () => container.removeEventListener('scroll', checkScroll);
  }, [document, soloLectura]);

  return (
    <LegalCartaMarco
      titulo={document.documentTypeName}
      version={`Versión ${document.versionNumber}`}
      cuerpoRef={contentRef}
      cuerpoClassName={soloLectura ? 'is-full' : ''}
      marcaAgua={soloLectura}
      despues={(
        <>
          {!soloLectura && !hasScrolledToEnd && (
            <p className="legal-sheet-hint">Desplázate hasta el final para poder aceptar</p>
          )}
          {!soloLectura && (
            <div className="legal-sheet-accept">
              <label className={`legal-declaracion${!hasScrolledToEnd ? ' is-disabled' : ''}`}>
                <input
                  type="checkbox"
                  checked={accepted}
                  onChange={(e) => onAcceptChange(e.target.checked)}
                  disabled={!hasScrolledToEnd}
                />
                <span>{document.checkboxText}</span>
              </label>
              {showWaiverOption && (
                <label className={`legal-declaracion${!hasScrolledToEnd ? ' is-disabled' : ''}`}>
                  <input
                    type="checkbox"
                    checked={waiverOfWithdrawal}
                    onChange={(e) => onWaiverChange(e.target.checked)}
                    disabled={!hasScrolledToEnd}
                  />
                  <span>
                    Quiero acceder al servicio de inmediato y entiendo que renuncio a mi derecho
                    de desistimiento de 14 días una vez el servicio haya comenzado a prestarse.
                  </span>
                </label>
              )}
            </div>
          )}
        </>
      )}
    >
      {parrafosDocumento(document.filledContent).map((parrafo, indice) => (
        <p key={indice}>{parrafo}</p>
      ))}
    </LegalCartaMarco>
  );
}

export default LegalDocumentViewer;
